export default "__VITE_ASSET__BevnQHav__"